import { MTGCard } from 'types/interfaces/mtgCard';
import { ConsolidatedCard } from 'store/services/cards/search/cardsSearchApi';
import './AddCardsSearchListItem.css';

interface Props {
  item: MTGCard | ConsolidatedCard;
  additionalStyle: string;
  onPress: () => void;
  mode?: 'any' | 'specific';
}

export const AddCardsSearchListItem = ({
  item,
  additionalStyle,
  onPress,
  mode = 'specific'
}: Props) => {
  // Type guard to check if item is ConsolidatedCard
  const isConsolidated = (item: any): item is ConsolidatedCard => {
    return 'cardName' in item && 'totalVersions' in item;
  };

  if (mode === 'any' && isConsolidated(item)) {
    // Display for "Any Set" mode (consolidated results)
    return (
      <div
        className={`add-cards-search-list-item ${additionalStyle}`}
        onClick={onPress}
      >
        <img 
          src={item.sampleImage?.art_crop || item.sampleImage?.small} 
          alt={item.cardName + ' image'} 
        />
        <div className="add-cards-search-list-item-name">{item.cardName}</div>
        {/* No set information for "Any Set" mode */}
      </div>
    );
  } else {
    // Display for "Specific Set" mode (MTG card results)
    const mtgCard = item as MTGCard;
    return (
      <div
        className={`add-cards-search-list-item ${additionalStyle}`}
        onClick={onPress}
      >
        <img src={mtgCard?.imageUris?.art_crop} alt={mtgCard.name + ' image'} />
        <div className="add-cards-search-list-item-name">{mtgCard.name}</div>
        <div className="add-cards-search-list-item-set-container">
          <div className="add-cards-search-list-item-set-name">
            {mtgCard.setName}
            {mtgCard.collectorNumber ? ' #' + mtgCard.collectorNumber : ''}
          </div>
        </div>
      </div>
    );
  }
};
